var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.rootClass }, [
    _vm.label ? _c("label", [_vm._v(_vm._s(_vm.label))]) : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "sip-segmented-control",
        attrs: {
          role: "group",
          "aria-label": _vm.ariaLabel || _vm.label || undefined,
        },
      },
      [
        _c(
          "button",
          {
            staticClass: "sip-segmented-btn",
            class: { "is-active": !_vm.isOn },
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.set(_vm.falseValue)
              },
            },
          },
          [
            _c("em", { staticClass: "icon ni ni-cross-sm" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.noText))]),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "sip-segmented-btn sip-segmented-btn--accent",
            class: { "is-active": _vm.isOn },
            attrs: { type: "button", disabled: _vm.disabled },
            on: {
              click: function ($event) {
                return _vm.set(_vm.trueValue)
              },
            },
          },
          [
            _c("em", { staticClass: "icon ni ni-check-sm" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.yesText))]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }